/**
 * organization Normalizr Schema
 */

import { schema } from 'normalizr';

import commodity from './commodity';

const organization = new schema.Entity('organizations', {
    commodities: [commodity]
});

export default organization;
